import {
    Menu,
    MenuDivider,
    MenuItem,
    MenuItemOption,
    MenuList,
    MenuOptionGroup,
    Text,
    useColorModeValue,
  } from '@chakra-ui/react'
  import { AccountSwitcherButton } from './AccountSwitcherButton'
import { useContext, useMemo } from 'react';
import { AppContext } from '../../App';
import { OrganizationContext } from '../../contexts/OrganizationProvider';
import { ApiContext } from '../../contexts/ApiProvider';
import { ZitadelContext } from '../../contexts/ZitadelProvider';
import { useNavigate } from 'react-router-dom'
import { FiCheck } from 'react-icons/fi';
  
  export const AccountSwitcher = () => {
    const { me } = useContext(AppContext);
    const { logout } = useContext(ZitadelContext);
    const { available, selected, setSelected } = useContext(OrganizationContext);
    const { organizations, setMe } = useContext(AppContext);
    const navigate = useNavigate();

    return (
      <Menu>
        <AccountSwitcherButton />
        <MenuList shadow="lg" py="4" color={'gray.600'} px="3">
          <Text fontWeight="medium" mb="2">
            {`${me.user.contact.firstName} ${me.user.contact.lastName}`}
          </Text>
          <MenuDivider />
          <MenuOptionGroup defaultValue={selected.id}>
            {available.map(a => (
                <MenuItemOption 
                    key={a.id}
                    value={a.id} 
                    rounded="md"
                    fontWeight={a.id === selected.id ? "semibold" : "normal"} 
                    isChecked={a.id === selected.id}
                    onClick={a.id === selected.id ? undefined : () => { setSelected(a); setMe(undefined); }}
                >
                    {organizations.find(o => o.id === a.id)?.identity.name}
                </MenuItemOption>
            ))}
          </MenuOptionGroup>
          <MenuDivider />
          {/* <MenuItem rounded="md">Einstellungen</MenuItem> */}
          <MenuItem key="asmi-profile" rounded="md"onClick={() => navigate(`/profile`)}>Profileinstellungen</MenuItem>
          <MenuItem key="asmi-password" rounded="md"onClick={() => navigate(`/profile/password`)}>Kennwort ändern</MenuItem>
          <MenuDivider />
          <MenuItem key="asmi-logout" rounded="md" onClick={() => logout()}>Abmelden</MenuItem>
        </MenuList>
      </Menu>
    )
  }